import { render, staticRenderFns } from "./statisticalView.vue?vue&type=template&id=f3ab1d4e&"
import script from "./statisticalView.vue?vue&type=script&lang=js&"
export * from "./statisticalView.vue?vue&type=script&lang=js&"
import style0 from "./statisticalView.vue?vue&type=style&index=0&id=f3ab1d4e&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3ab1d4e')) {
      api.createRecord('f3ab1d4e', component.options)
    } else {
      api.reload('f3ab1d4e', component.options)
    }
    module.hot.accept("./statisticalView.vue?vue&type=template&id=f3ab1d4e&", function () {
      api.rerender('f3ab1d4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/investigate/statistical/statisticalView.vue"
export default component.exports